export var companyAdd = function companyAdd(_this) {
  return [{
    label: _this.$t('1241'),
    value: 'building',
    maxlength: 100
  }, {
    label: _this.$t('1242'),
    value: 'room_no',
    maxlength: 100
  }, {
    label: _this.$t('1243'),
    value: 'floor',
    maxlength: 100
  }, {
    label: _this.$t('1244'),
    value: 'village',
    maxlength: 100
  }, {
    label: _this.$t('1245'),
    required: true,
    value: 'house_no',
    maxlength: 100
  }, {
    label: _this.$t('1246'),
    value: 'village_no',
    maxlength: 100
  }, {
    label: _this.$t('1247'),
    value: 'street',
    maxlength: 100
  }, {
    label: _this.$t('1248'),
    value: 'intersection',
    maxlength: 100
  }, {
    label: _this.$t('1249'),
    value: 'road',
    maxlength: 100
  }, {
    required: true,
    label: _this.$t('1250'),
    value: 'town',
    maxlength: 100
  }, {
    required: true,
    label: _this.$t('1251'),
    value: 'county',
    maxlength: 100
  }, {
    required: true,
    label: _this.$t('1252'),
    value: 'prefecture',
    maxlength: 100
  }, {
    required: true,
    label: _this.$t('1253'),
    value: 'postcode',
    maxlength: 5
  }];
};
export var companyAddEn = function companyAddEn(_this) {
  return [{
    label: _this.$t('1241'),
    value: 'building_en',
    maxlength: 100
  }, {
    label: _this.$t('1242'),
    value: 'room_no_en',
    maxlength: 100
  }, {
    label: _this.$t('1243'),
    value: 'floor_en',
    maxlength: 100
  }, {
    label: _this.$t('1244'),
    value: 'village_en',
    maxlength: 100
  }, {
    label: _this.$t('1245'),
    value: 'house_no_en',
    maxlength: 100
  }, {
    label: _this.$t('1246'),
    value: 'village_no_en',
    maxlength: 100
  }, {
    label: _this.$t('1247'),
    value: 'street_en',
    maxlength: 100
  }, {
    label: _this.$t('1248'),
    value: 'intersection_en',
    maxlength: 100
  }, {
    label: _this.$t('1249'),
    value: 'road_en',
    maxlength: 100
  }, {
    label: _this.$t('1250'),
    value: 'town_en',
    maxlength: 100
  }, {
    label: _this.$t('1251'),
    value: 'county_en',
    maxlength: 100
  }, {
    label: _this.$t('1252'),
    value: 'prefecture_en',
    maxlength: 100
  }, {
    label: _this.$t('1253'),
    value: 'postcode_en',
    maxlength: 5
  }];
};